import useGetCrypto from '@/hooks/useGetCrypto';
import { Stack, useTheme } from '@mui/material';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import Image from 'next/image';
import find from 'lodash/find';
import { FC } from 'react';
import { BadgeHeaderT } from '../types';

const HeaderBadgeComponent: FC<BadgeHeaderT> = ({
  name_en,
  endLogo,
  startLogo,
  name_fa,
  symbol,
  isScam
}) => {
  const { matches } = useResponsive();
  const theme = useTheme();

  const symbolFilter = [
    `${(symbol || '')?.toString().toUpperCase()}USDT`,
    `${(symbol || '')?.toString().toUpperCase()}TMN`
  ];
  const { result } = useGetCrypto(
    {
      get: {
        side: 'otc',
        filter: symbolFilter
      }
    },
    'getCurrentList',
    symbolFilter
  );

  const currentAsset = find(
    result || [],
    item => item.quote === (item.base === 'USDT' ? 'TMN' : 'USDT')
  );
  return (
    <>
      <Stack
        alignItems="center"
        direction="row"
        sx={{
          background: theme.palette.grayBackground.A20,
          py: matches({ lg: 4, xs: 2.5 }),
          px: matches({ xs: 4, lg: 6 }),
          borderRadius: '12px'
        }}
      >
        {currentAsset?.logoUrl && startLogo && (
          <Image
            src={currentAsset?.logoUrl}
            alt=""
            width={matches({ lg: 42, xs: 24 })}
            height={matches({ lg: 42, xs: 24 })}
          />
        )}
        <Typography
          component="p"
          sx={{ display: 'flex', flex: '50%', ml: 2 }}
          variant={matches({ lg: 'title', xs: 'body2' })}
          weight={matches({ lg: 'bolder', xs: 'bold' })}
        >
          {isScam ? `${name_fa}:` : `${name_fa} در یک  نگاه:`}
        </Typography>
        <Stack
          direction="row"
          spacing={matches({ lg: 1, xs: 0 })}
          sx={{ direction: 'rtl' }}
          alignItems="center"
        >
          {currentAsset?.logoUrl && endLogo && (
            <Image
              src={currentAsset?.logoUrl}
              alt=""
              width={matches({ lg: 38, xs: 25 })}
              height={matches({ lg: 38, xs: 25 })}
            />
          )}

          <Typography
            component="p"
            variant={matches({ lg: 'title', xs: 'body2' })}
            weight="bold"
            sx={{ pr: 2 }}
          >
            {name_en}
          </Typography>
          <Typography
            component="p"
            variant={matches({ lg: 'title', xs: 'body3' })}
          >
            ({currentAsset?.base})
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};

export default HeaderBadgeComponent;
